"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMachineConfigContext = void 0;
const react_1 = require("react");
const MachineConfigContext_1 = require("./MachineConfigContext");
const useMachineConfigContext = () => {
    const context = (0, react_1.useContext)(MachineConfigContext_1.MachineConfigContext);
    if (!context) {
        throw new Error('useMachineConfigContext must be used within a MachineConfigProvider');
    }
    return context;
};
exports.useMachineConfigContext = useMachineConfigContext;
